import { PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { SagaIterator } from "redux-saga";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { setToast } from "scenes/redux";
import { selectToken, selectUserCidpId } from "scenes/selectors";
import { APIError, APIResponseError } from "types/ApiErrorResponse";
import factory from "utils/getApiHandlerEffect";
import {
  afterApiPasswordError,
  afterPasswordPoliciesLoad,
  loadPasswordPolicies,
  submitChangePassword,
} from "./redux";

export function* onLoad(): SagaIterator {
  const cidpId = yield select(selectUserCidpId);
  const accessToken = yield select(selectToken);
  const apiHandler: APIHandler = yield call(() => factory());
  try {
    const response = yield call(() =>
      apiHandler.getAuthenticatedPasswordPolicies(cidpId, accessToken)
    );
    yield put(afterPasswordPoliciesLoad(response));
  } catch (e: any) {
    // yield setError(true);
  }
}

export function* updatePassword(action: PayloadAction<any>): SagaIterator {
  const cidpId = yield select(selectUserCidpId);
  const accessToken = yield select(selectToken);
  const apiHandler: APIHandler = yield call(() => factory());
  try {
    yield call(() =>
      apiHandler.submitUpdatePassword(cidpId, accessToken, action.payload)
    );
    yield put(
      setToast({
        message: "Password Updated.",
        messageType: "positive",
        label: "Success",
      })
    );
    yield put(push("/dashboard/securitysettings"));
  } catch (e: any) {
    if ((<APIError>e).statusCode === 400) {
      const error: APIResponseError = JSON.parse((<APIError>e).body);
      if (error.errors[0].message.includes("Old Password is not correct")) {
        yield put(afterApiPasswordError("CURRENT_PASSWORD_INCORRECT"));
      } else {
        yield put(afterApiPasswordError(null));
        yield put(
          setToast({
            message: "Password could not be updated.",
            messageType: "error",
            label: "Something went wrong.",
          })
        );
        yield put(push("/dashboard/securitysettings"));
      }
    } else {
      yield put(
        setToast({
          message: "Password could not be updated.",
          messageType: "error",
          label: "Something went wrong.",
        })
      );
      yield put(push("/dashboard/securitysettings"));
    }
  }
}

// watcher function
export default function* editPasswordSaga() {
  yield takeLatest(submitChangePassword.type, updatePassword);
  yield takeLatest(loadPasswordPolicies.type, onLoad);
}
